/*
 * Keycodez - Simple and quick keycodes map
 *
 * Copyright (c) 2014 Andrew Hathaway, https://github.com/AndrewHathaway/keycodez
 *
 * The MIT License (MIT)
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
module.exports = {
  3   : 'break',
  8   : 'backspaceDelete',
  9   : 'tab',
  12  : 'clear',
  13  : 'enter',
  16  : 'shift',
  17  : 'ctrl',
  18  : 'alt',
  19  : 'pauseBreak',
  20  : 'capsLock',
  27  : 'escape',
  32  : 'spacebar',
  33  : 'pageUp',
  34  : 'pageDown',
  35  : 'end',
  36  : 'home',
  37  : 'leftArrow',
  38  : 'upArrow',
  39  : 'rightArrow',
  40  : 'downArrow',
  41  : 'select',
  42  : 'print',
  43  : 'execute',
  44  : 'printScreen',
  45  : 'insert',
  46  : 'delete',
  48  : '0',
  49  : '1',
  50  : '2',
  51  : '3',
  52  : '4',
  53  : '5',
  54  : '6',
  55  : '7',
  56  : '8',
  57  : '9',
  65  : 'a',
  66  : 'b',
  67  : 'c',
  68  : 'd',
  69  : 'e',
  70  : 'f',
  71  : 'g',
  72  : 'h',
  73  : 'i',
  74  : 'j',
  75  : 'k',
  76  : 'l',
  77  : 'm',
  78  : 'n',
  79  : 'o',
  80  : 'p',
  81  : 'q',
  82  : 'r',
  83  : 's',
  84  : 't',
  85  : 'u',
  86  : 'v',
  87  : 'w',
  88  : 'x',
  89  : 'y',
  90  : 'z',
  91  : 'windowsKeyLeftCMD',
  92  : 'windowsKeyRight',
  93  : 'windowsKeyRightCMD',
  96  : 'numpad0',
  97  : 'numpad1',
  98  : 'numpad2',
  99  : 'numpad3',
  100 : 'numpad4',
  101 : 'numpad5',
  102 : 'numpad6',
  103 : 'numpad7',
  104 : 'numpad8',
  105 : 'numpad9',
  106 : 'multiply',
  107 : 'add',
  109 : 'subtract',
  110 : 'decimalPoint',
  111 : 'divide',
  112 : 'f1',
  113 : 'f2',
  114 : 'f3',
  115 : 'f4',
  116 : 'f5',
  117 : 'f6',
  118 : 'f7',
  119 : 'f8',
  120 : 'f9',
  121 : 'f10',
  122 : 'f11',
  123 : 'f12',
  124 : 'f13',
  125 : 'f14',
  126 : 'f15',
  127 : 'f16',
  128 : 'f17',
  129 : 'f18',
  130 : 'f19',
  144 : 'numLock',
  145 : 'scrollLock',
  173 : 'toggleMute',
  174 : 'decreaseVolume',
  175 : 'increaseVolume',
  181 : 'fireboxToggleMute',
  182 : 'firefoxDecreaseVolume',
  183 : 'firefoxIncreaseVolume',
  186 : 'semiColon',
  187 : 'equalSign',
  188 : 'comma',
  189 : 'dash',
  190 : 'period',
  191 : 'forwardSlash',
  192 : 'graveAccent',
  219 : 'openBracket',
  220 : 'backSlash',
  221 : 'closeBracket',
  222 : 'singleQuote',
  224 : 'firefoxCMD',
  225 : 'altgr',
  255 : 'toggleTouchpad'
};